const Loader = ({ className }: any) => {
  return <div className={`loader ${className}`}>Loader</div>;
};

export default Loader;
